module.exports = __webpack_public_path__ + "img/num2.ef9f6762.png";